import { useEffect, useRef } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import IdleLogout from "@/components/IdleLogout";
import ViewAsBanner from "@/components/ViewAsBanner";
import Hub from "@/pages/Hub";
import Toolkit from "@/pages/Toolkit";
import Congrats from "@/pages/Congrats";
import WinnerPage from "@/pages/WinnerPage";
import Gallery from "@/pages/Gallery";
import PressRelease from "@/pages/PressRelease";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";
import AdminApprovedEmails from "@/pages/AdminApprovedEmails";
import AdminUsers from "@/pages/AdminUsers";
import AdminActivity from "@/pages/AdminActivity";
import AdminToolkitContent from "@/pages/AdminToolkitContent";
import Account from "@/pages/Account";

function ScrollToTop() {
  const { pathname } = useLocation();
  const first = useRef(true);
  useEffect(() => {
    window.scrollTo(0, 0);
    if (first.current) { first.current = false; return; }
    try { window._statcounter?.record_pageview?.(); } catch (e) { console.warn("StatCounter pageview failed", e); }
  }, [pathname]);
  return null;
}

function App() {
  useEffect(() => {
    if ("fonts" in document) document.fonts.load("800 80px Jost");
  }, []);
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <ViewAsBanner />
          <IdleLogout />
          <Routes>
            <Route path="/" element={<Hub />} />
            <Route path="/bgjcpt" element={<Congrats gate />} />
            <Route path="/bgjcpt/welcome" element={<Congrats />} />
            <Route path="/bgjcpt/create" element={<Toolkit />} />
            <Route path="/bgjcpt/gallery" element={<Gallery />} />
            <Route path="/bgjcpt/press/:slug" element={<PressRelease />} />
            <Route path="/bgjcpt/:slug" element={<WinnerPage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/admin/login" element={<Login staff />} />
            <Route path="/account" element={<Account />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/admin/users" element={<AdminUsers />} />
            <Route path="/admin/activity" element={<AdminActivity />} />
            <Route path="/admin/:toolkit/approved" element={<AdminApprovedEmails />} />
            <Route path="/admin/:toolkit/content" element={<AdminToolkitContent />} />
            <Route path="/admin/:toolkit" element={<Admin />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
